module.exports = __webpack_public_path__ + "img/Brazil.5a39d937.png";